// extracted by mini-css-extract-plugin
module.exports = {"area-height":"70vh","modal-width":"50vw","asset":"ExpandedAssetModal_asset__1UrDC","modal":"ExpandedAssetModal_modal__99EEx"};